export const TABNAMES = {
  '/datacenter/balance': '余额查询',
  '/datacenter/current': '活期宝查询',
  '/datacenter/tradefee': '手续费查询',
  '/datacenter/contract': '合约查询',
  '/datacenter/tribeprofit': '部落收益查询',
  '/datacenter/walletbill': '充提统计查询',
  '/datacenter/pledge': '定期宝查询',
  '/datacenter/user': '用户数据',
  '/datacenter/stakingData': 'staking数据',
  '/datacenter/tradeVoulmeData': '交易量数据',
  '/datacenter/dwsummary': '充提整体数据',
  '/datacenter/rechangeReturn': '充值退回'
}
export const TX_STATUS = {
  's-1': '失败',
  's0': '已经确认',
  's1': '已提交',
  's2': '取消',
  's3': '确认中',
  's4': '已审核',
  's5': '区块链网络已经发送， 等待确认中',
  's6': '系统错误',
  's7': '管理员退回',
  's8': '大额充值复审',
  's9': 'Cobo提现发送中',
  's10': '充提成功，等待资金变更',
  's11': 'safe确认中'
}

export const STATUSLIST = [
    {label: '全部', value: 'ALL'},
    {label: '初始化,等待审批', value: 'INIT'},
    {label: '二次审核中', value: 'RE_CHECK'},
    {label: '用户取消', value: 'CANCEL'},
    {label: '核通过,待转账', value: 'PASS'},
    {label: '转账中', value: 'EXECUTING_TRANSFER'},
    {label: '转账失败', value: 'FAIL'},
    {label: '审核不通过', value: 'REFUSE'},
    {label: '转账成功', value: 'SUCCESS'},
]
